import { render, staticRenderFns } from "./main-mobile.vue?vue&type=template&id=7524dd84&lang=pug&"
import script from "./main-mobile.vue?vue&type=script&lang=js&"
export * from "./main-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports